import {matchPath} from 'react-router';
import Paths from './Paths';

export default function requireRegistrationForPath(path: string): boolean {
  return !!matchPath(Paths.RawBillingTariff, path);
}